export function computeChecklistVisibility({
	hasWorkspace,
	isTrial,
	progress,
}: {
	hasWorkspace: boolean
	isTrial: boolean
	progress: number
}) {
	return hasWorkspace && isTrial && progress !== 1
}
